"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssetService = void 0;
const caip_1 = require("@shapeshiftoss/caip");
const axios_1 = __importDefault(require("axios"));
const node_polyglot_1 = __importDefault(require("node-polyglot"));
const descriptions_1 = __importDefault(require("./descriptions"));
const generatedAssetData_json_1 = __importDefault(require("./generatedAssetData.json"));
class AssetService {
    constructor() {
        this.assets = generatedAssetData_json_1.default;
    }
    getAll() {
        return this.assets;
    }
    async description(assetId, locale = 'en') {
        var _a;
        const localeDescriptions = descriptions_1.default[locale];
        // Return overridden asset description if it exists and add isTrusted for description links
        if (localeDescriptions[assetId] || descriptions_1.default.en[assetId]) {
            const polyglot = new node_polyglot_1.default({
                phrases: localeDescriptions,
                allowMissing: true,
                onMissingKey: (key) => descriptions_1.default.en[key], // fallback to English overriden description, which should always be added as a base translation
            });
            const overriddenDescription = polyglot.t(assetId);
            return { description: overriddenDescription, isTrusted: true };
        }
        try {
            const url = caip_1.adapters.makeCoingeckoAssetUrl(assetId);
            if (!url)
                throw new Error();
            const { data } = await axios_1.default.get(url);
            if (!(data === null || data === void 0 ? void 0 : data.description))
                return { description: '' };
            const description = (_a = (data.description[locale] || data.description.en)) !== null && _a !== void 0 ? _a : '';
            return { description };
        }
        catch (e) {
            const errorMessage = `AssetService:description: no description available for ${assetId}`;
            throw new Error(errorMessage);
        }
    }
}
exports.AssetService = AssetService;
